import { toIsoDate } from '../../../../util/shared/tmc-global';
import { amountToNumber } from '../../../../util/shared/vue-global';

// taxCommonPostProcessTrans (CommonTaxFunctionalities.js) adds a hex color key
// (e.g. "#FFB74D": true) on each item for CRUDRow highlighting; strip it before
// sending the item to the taxTransactionInputType GraphQL mutation.
const removeHighlightColorKey = (item) => {
  Object.keys(item)
    .filter((key) => /^#[0-9A-Fa-f]{3,8}$/.test(key))
    .forEach((key) => {
      // eslint-disable-next-line no-param-reassign
      delete item[key];
    });
};

export const taxFeesUpsertCommon = (val, taxFeeMasterData) => {
  const feeNumber = val.feeNumber ? val.feeNumber : null;
  let feeDesc = val.feeDescription ? val.feeDescription : null;
  const checkTaxFee = taxFeeMasterData.length ? taxFeeMasterData : [];
  if (!feeDesc) {
    const filteredTaxMasterList = checkTaxFee.filter((ft) => ft.feeNumber === feeNumber);
    feeDesc = filteredTaxMasterList.length > 0 ? filteredTaxMasterList[0].feeDescription : null;
  }
  const feeAmount = amountToNumber(val.feeAmount);
  let feeItem = {};
  if (feeAmount && feeNumber) {
    feeItem = {
      feeAmount,
      feeDescription: feeDesc,
      feeNumber,
      taxId: val.taxId,
      taxYear: val.taxYear,
    };
  }
  return feeItem;
};

export const taxAdjUpsertCommon = (val) => {
  const checkDate = val.certDateValue ? toIsoDate(val.certDateValue) : null;
  const updatedItem = {
    adjOrUpd: 'ADJUST',
    improvementVal: amountToNumber(val.improvements),
    landVal: amountToNumber(val.land),
    mobileVal: amountToNumber(val.mobileHome),
    penaltyVal: amountToNumber(val.assessorPenalty),
    posted: true,
    certNumber: amountToNumber(val.certificateNumber),
    certDate: checkDate,
    schoolDistrict: val.taxDistrict || val.schoolDistrict,
    taxAmt: amountToNumber(val.totalTax),
    taxId: val.taxId,
    taxYear: val.taxYear,
    totalExemptions: amountToNumber(val.exemptions),
    type: val.taxAdjTypesList,
    valuesAfterAdjustment: {
      land: amountToNumber(val.land),
      improvements: amountToNumber(val.improvements),
      mobileHome: amountToNumber(val.mobileHome),
      exemptions: amountToNumber(val.exemptions),
      totalTax: amountToNumber(val.totalTax),
      assessorPenalty: amountToNumber(val.assessorPenalty),
    },
    valuesBeforeAdjustment: {
      name: val.name1,
      land: 0,
      improvements: 0,
      mobileHome: 0,
      exemptions: 0,
      totalTax: 0,
      assessorPenalty: 0,
      schoolDistrict: val.taxDistrict,
    },
  };
  return updatedItem;
};

export const taxInquryUpsertCommonFromCreateNewOmit = (val) => {
  const item = { ...val };
  const feeAmount = amountToNumber(val.feeAmount);
  let feeTotal = 0;
  if (feeAmount && val.feeNumber)feeTotal = feeAmount;
  const checkDate = item.penaltyStartDate ? toIsoDate(item.penaltyStartDate) : null;
  item.totalTax = amountToNumber(item.totalTax);
  item.schoolDistrict = item.taxDistrict || item.schoolDistrict;
  item.mhDecalDate = item.mhDecalDate ? toIsoDate(item.mhDecalDate) : null;
  item.penaltyStartDate = checkDate;
  item.totalFee = feeTotal;
  item.pIdOfRealEstate = (item.pIdOfRealEstate || '').replace(/-/g, '');
  item.propertyOrParcelId = (item.propertyOrParcelId || '').replace(/-/g, '');
  delete item.feeAmount;
  delete item.taxDistrict;
  delete item.hasFiles;
  delete item.stillDue;
  delete item.penaltyDateValue;
  delete item.getPenRateWithMonths;
  delete item.taxAdjTypesList;
  delete item.taxFeeList;
  delete item.feeNumber;
  delete item.adjTypes;
  delete item.staCode;
  delete item.totalPaid;
  delete item.totalDue;
  delete item.certDateValue;
  delete item.certificateNumber;
  delete item.feesAndPen;
  delete item.penaltyAmount;
  removeHighlightColorKey(item);
  return item;
};

export const taxInquryUpsertCommonForOmitAndSA = (val) => {
  const item = { ...val };
  const feeAmount = amountToNumber(val.feeAmount);
  let feeTotal = 0;
  if (feeAmount && val.feeNumber)feeTotal = feeAmount;
  const checkDate = item.penaltyStartDate ? toIsoDate(item.penaltyStartDate) : null;
  item.totalTax = amountToNumber(item.totalTax);
  item.schoolDistrict = item.taxDistrict || item.schoolDistrict;
  item.mhDecalDate = item.mhDecalDate ? toIsoDate(item.mhDecalDate) : null;
  item.penaltyStartDate = checkDate;
  item.totalFee = feeTotal;
  item.pIdOfRealEstate = (item.pIdOfRealEstate || '').replace(/-/g, '');
  item.propertyOrParcelId = (item.propertyOrParcelId || '').replace(/-/g, '');
  delete item.feeAmount;
  delete item.taxDistrict;
  delete item.hasFiles;
  delete item.stillDue;
  delete item.penaltyDateValue;
  delete item.getPenRateWithMonths;
  delete item.taxAdjTypesList;
  delete item.taxFeeList;
  delete item.feeNumber;
  delete item.adjTypes;
  delete item.staCode;
  delete item.totalPaid;
  delete item.totalDue;
  delete item.certDateValue;
  delete item.certificateNumber;
  delete item.feesAndPen;
  delete item.penaltyAmount;
  removeHighlightColorKey(item);
  return item;
};
